import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemsGetRequest = simpleAction(TYPES.ITEMS_GET_REQUEST);

/**
 * Request items success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemsGetSuccess = simpleAction(TYPES.ITEMS_GET_SUCCESS);

/**
 * Request items error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemsGetError = simpleAction(TYPES.ITEMS_GET_FAIL);

/**
 * Request items error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemsGetDone = simpleAction(TYPES.ITEMS_GET_DONE);

/**
 * Request Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemLoadRequest = simpleAction(TYPES.ITEM_LOAD_REQUEST);

/**
 * Request Product success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemLoadSuccess = simpleAction(TYPES.ITEM_LOAD_SUCCESS);

/**
 * Request Product error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemLoadError = simpleAction(TYPES.ITEM_LOAD_FAIL);

/**
 * Create Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemCreateRequest = simpleAction(TYPES.ITEM_CREATE_REQUEST);

/**
 * Create Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemCreateSuccess = simpleAction(TYPES.ITEM_CREATE_SUCCESS);

/**
 * Create Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemCreateError = simpleAction(TYPES.ITEM_CREATE_FAIL);

/**
 * Create Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemCreateDone = simpleAction(TYPES.ITEM_CREATE_DONE);

/**
 * Update Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemUpdateRequest = simpleAction(TYPES.ITEM_UPDATE_REQUEST);

/**
 * Update Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemUpdateSuccess = simpleAction(TYPES.ITEM_UPDATE_SUCCESS);

/**
 * Update Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemUpdateError = simpleAction(TYPES.ITEM_UPDATE_FAIL);

/**
 * Update Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const itemUpdateDone = simpleAction(TYPES.ITEM_UPDATE_DONE);
